<ion-content class="garment-pick-up">
    <ng-container>
        <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Pick Up'" [breadcrumbs]="breadcrumbs"></app-header>

        <ion-grid style="padding-top:120px">
            <ion-row>
                <ion-col class="align" *ngIf="showScanner">
                    <ion-label class="label">Scan Garments:</ion-label>
                    <textarea class="textarea" [(ngModel)]="garmentCodes"></textarea>
                    <ion-button (click)="savePickUp()" style="--background: #006633;">Save</ion-button>
                </ion-col>
                <ion-col class="align">
                    <ion-label class="label">Show Scans for Date: </ion-label>
                    <ion-datetime (ionChange)="showScans($event)"></ion-datetime>
                </ion-col>
            </ion-row>
            <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
            </div>
            <ion-row *ngIf="showScansList">
                <div class="datatable">
                    <ngx-datatable class="bootstrap" [rows]="garmentList" [rowHeight]="50" [sortType]="'multi'" [headerHeight]="50"
                        [footerHeight]="50" [columnMode]="'force'" [scrollbarH]="false">

                        <ngx-datatable-column name="Garment" prop="garmentCode">
                            <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                                <a><span class="primaryKey"></span>&nbsp;{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Product" prop="productCode">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a class="productCode">{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Employee" prop="employeeCode">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a class="employeeCode">{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </div>
            </ion-row>
            <ion-row *ngIf="showScansList" class="align">
                <ion-button (click)="scanner()" style="--background: #006633;">Scan Again</ion-button>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>